var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImpressiveVisuals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.066 111.066C75.6714 111.066 51.2766 111.053 26.8819 111.097C25.5602 111.097 25.1511 110.845 25.1574 109.42C25.2077 85.6525 25.1888 61.885 25.1951 38.1176C25.1951 31.635 29.7518 27.0126 36.2156 27.0126C79.7246 27 123.227 27 166.736 27.0063C171.689 27.0063 174.956 30.3422 174.962 35.3366C174.962 60.0374 174.95 84.7381 175.006 109.439C175.006 110.908 174.528 111.091 173.257 111.085C148.862 111.053 124.467 111.059 100.072 111.059L100.066 111.066ZM128.313 33.8484C120.068 33.8042 114.252 35.015 108.733 37.5942C100.828 41.2895 94.6157 47.0974 88.9764 53.5989C87.9946 54.734 88.1834 55.7934 89.4233 56.9978C93.338 60.7941 97.5675 64.1993 102.25 66.9992C112.591 73.1791 123.592 75.4745 135.425 72.4287C145.86 69.7423 154.476 63.8462 162.4 56.7897C163.552 55.7619 163.545 54.5952 162.438 53.3845C160.587 51.3539 158.674 49.3865 156.792 47.3874C148.478 38.5653 138.553 33.407 128.319 33.8421L128.313 33.8484ZM35.3974 53.7124C35.3974 59.4698 35.3974 65.2272 35.3974 70.9846C35.3974 73.0782 36.0834 73.7467 38.1918 73.7467C47.9787 73.7467 57.7592 73.7467 67.5461 73.7467C69.6985 73.7467 70.4097 73.1098 70.416 71.0162C70.4349 59.5518 70.4349 48.0874 70.416 36.623C70.416 34.5294 69.6797 33.8484 67.5838 33.8484C57.797 33.8484 48.0164 33.8484 38.2296 33.8484C36.0645 33.8484 35.3974 34.5357 35.3911 36.7429C35.3911 42.3994 35.3911 48.0496 35.3911 53.7061L35.3974 53.7124ZM147.943 85.23C143.544 85.23 139.144 85.23 134.751 85.23C132.404 85.23 131.749 85.9047 131.749 88.2947C131.749 93.3774 131.749 98.4537 131.749 103.536C131.749 105.611 132.479 106.387 134.512 106.387C143.411 106.399 152.311 106.399 161.21 106.387C163.237 106.387 164.017 105.598 164.024 103.543C164.049 98.4096 164.043 93.2765 164.024 88.1434C164.017 85.9299 163.262 85.23 160.984 85.2237C156.635 85.2237 152.292 85.2237 147.943 85.2237V85.23ZM66.9607 91.0946C57.5452 91.0946 48.1297 91.0946 38.7142 91.0946C38.1981 91.0946 37.6694 91.0567 37.1659 91.1387C36.1211 91.3027 35.5107 91.9585 35.4225 93.0179C35.3281 94.1404 35.8316 94.9539 36.9393 95.225C37.5813 95.3827 38.2736 95.3701 38.9408 95.3701C57.5641 95.3764 76.1874 95.3764 94.8108 95.3701C95.4779 95.3701 96.1702 95.3701 96.8122 95.225C97.9325 94.9665 98.4171 94.1278 98.3353 93.0242C98.2535 91.9837 97.6619 91.2964 96.5982 91.1387C96.0884 91.0631 95.566 91.0946 95.0499 91.0946C85.6848 91.0946 76.3196 91.0946 66.9607 91.0946ZM59.8802 84.3597C66.967 84.3597 74.0601 84.3597 81.147 84.3597C81.6127 84.3597 82.0847 84.3913 82.5442 84.3219C83.5952 84.1579 84.2057 83.5273 84.2939 82.4553C84.3883 81.3328 83.9162 80.5131 82.8085 80.2293C82.2169 80.0779 81.5812 80.0842 80.9644 80.0779C66.8915 80.0716 52.8123 80.0716 38.7394 80.0779C38.1729 80.0779 37.5939 80.0779 37.04 80.1978C35.8253 80.4563 35.1204 81.6229 35.4666 82.7958C35.8316 84.0381 36.782 84.3724 37.9967 84.3724C45.2912 84.3534 52.592 84.3597 59.8865 84.366L59.8802 84.3597ZM50.4521 102.036C46.3674 102.036 42.2828 102.036 38.1981 102.036C36.3414 102.036 35.4162 102.773 35.41 104.192C35.41 105.592 36.3729 106.387 38.1918 106.387C46.3612 106.399 54.5242 106.399 62.6935 106.387C64.4747 106.387 65.5195 105.548 65.5195 104.199C65.5195 102.855 64.4747 102.036 62.6998 102.029C58.6152 102.023 54.5305 102.029 50.4458 102.029L50.4521 102.036Z",
    fill: "url(#paint0_linear_14_221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.072 115.429C124.461 115.429 148.843 115.442 173.231 115.398C174.66 115.398 175.094 115.77 174.994 117.189C174.78 120.184 175.327 123.217 174.692 126.181C173.653 131.081 169.537 134.486 164.546 134.701C164.187 134.713 163.822 134.713 163.457 134.713C121.207 134.713 78.963 134.713 36.7128 134.713C30.7148 134.713 26.2336 131.188 25.3336 125.582C25.0315 123.709 25.1699 121.754 25.2077 119.837C25.2329 118.406 24.5594 116.501 25.5098 115.682C26.3217 114.975 28.1658 115.436 29.5567 115.436C53.064 115.429 76.5651 115.436 100.072 115.436V115.429ZM99.9906 126.068C101.904 126.068 103.817 126.087 105.731 126.061C107.159 126.042 108.179 125.185 108.135 123.987C108.084 122.644 107.291 121.83 105.976 121.811C102.049 121.754 98.115 121.754 94.1814 121.811C92.866 121.83 92.0604 122.631 92.01 123.98C91.966 125.179 92.9793 126.042 94.4017 126.068C96.2646 126.093 98.1276 126.074 99.9906 126.074V126.068Z",
    fill: "url(#paint1_linear_14_221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.079 173.987C88.4792 173.987 76.8797 174 65.2803 173.987C61.8187 173.987 59.3515 171.963 58.6277 168.64C57.8347 164.995 60.6984 161.18 64.4243 160.921C64.8397 160.89 65.2551 160.896 65.6642 160.896C88.6051 160.896 111.546 160.896 134.487 160.896C137.898 160.896 140.309 162.466 141.284 165.272C142.763 169.504 139.704 173.95 135.185 173.975C125.556 174.025 115.92 173.994 106.291 173.994C104.22 173.994 102.149 173.994 100.079 173.994V173.987Z",
    fill: "url(#paint2_linear_14_221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.717 156.463H77.3518C78.5917 152.572 79.5295 148.713 80.0267 144.759C80.2029 143.372 80.4924 141.978 80.4609 140.597C80.4295 139.216 80.9896 139.02 82.1917 139.027C89.6939 139.077 97.2024 139.052 104.705 139.052C109.104 139.052 113.503 139.077 117.903 139.033C118.922 139.02 119.294 139.26 119.375 140.376C119.753 145.345 120.722 150.207 122.245 154.956C122.403 155.441 122.548 155.927 122.717 156.463Z",
    fill: "url(#paint3_linear_14_221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.034 69.408C116.103 69.4206 108.311 66.1163 101.111 61.1219C98.6814 59.4382 96.3905 57.5779 94.2128 55.5789C93.7974 55.2005 93.5205 54.9483 94.0555 54.3618C99.7199 48.1819 105.907 42.6326 114.082 40.1543C127.828 35.9797 140.466 37.8652 151.247 48.0369C153.318 49.9917 155.244 52.098 157.251 54.1159C157.761 54.6267 157.982 54.9609 157.264 55.56C149.655 61.8975 141.435 67.018 131.516 68.872C129.37 69.2693 127.211 69.4206 125.034 69.4017V69.408ZM125.877 39.9715C118.236 39.9273 112.031 46.0316 111.924 53.6934C111.823 61.3111 118.142 67.6865 125.801 67.6865C133.373 67.6865 139.528 61.5822 139.61 54.0024C139.686 46.2018 133.637 40.0156 125.883 39.9651L125.877 39.9715Z",
    fill: "url(#paint4_linear_14_221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7023 53.6366C39.7023 49.0206 39.7526 44.3983 39.6708 39.7823C39.6457 38.4391 40.0799 38.1742 41.3324 38.1805C49.0989 38.2373 56.8655 38.2373 64.6383 38.1805C65.8656 38.1742 66.1929 38.5084 66.1866 39.7318C66.1362 49.1215 66.1362 58.5175 66.1866 67.9072C66.1929 69.181 65.7775 69.4459 64.6005 69.4395C56.7837 69.3954 48.9605 69.3891 41.1436 69.4395C39.9603 69.4459 39.6645 69.0927 39.6834 67.9513C39.7464 63.1777 39.7086 58.404 39.7086 53.6303L39.7023 53.6366Z",
    fill: "url(#paint5_linear_14_221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.924 89.6063C151.386 89.6063 154.854 89.6441 158.315 89.5873C159.341 89.5684 159.769 89.7702 159.744 90.9242C159.668 94.1844 159.668 97.451 159.744 100.711C159.769 101.846 159.36 102.067 158.321 102.061C151.342 102.023 144.362 102.023 137.388 102.061C136.425 102.061 136.016 101.865 136.041 100.793C136.104 97.4825 136.104 94.1655 136.041 90.8486C136.022 89.7702 136.432 89.5747 137.388 89.5873C140.9 89.6315 144.418 89.6063 147.93 89.6063H147.924Z",
    fill: "url(#paint6_linear_14_221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.26 53.8008C116.26 48.5478 120.628 44.1777 125.839 44.2156C131.025 44.2534 135.274 48.51 135.343 53.7251C135.406 58.9465 131.057 63.367 125.833 63.3859C120.615 63.4048 116.26 59.0474 116.26 53.7944V53.8008Z",
    fill: "url(#paint7_linear_14_221)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_221",
    x1: 100.082,
    y1: 27.0022,
    x2: 100.082,
    y2: 111.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14_221",
    x1: 100.005,
    y1: 115.288,
    x2: 100.005,
    y2: 134.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14_221",
    x1: 100.078,
    y1: 160.896,
    x2: 100.078,
    y2: 174.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14_221",
    x1: 100.035,
    y1: 139.027,
    x2: 100.035,
    y2: 156.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14_221",
    x1: 125.741,
    y1: 38.0808,
    x2: 125.741,
    y2: 69.4081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14_221",
    x1: 52.9282,
    y1: 38.1804,
    x2: 52.9282,
    y2: 69.4397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14_221",
    x1: 147.893,
    y1: 89.5862,
    x2: 147.893,
    y2: 102.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14_221",
    x1: 125.802,
    y1: 44.2153,
    x2: 125.802,
    y2: 63.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 147,
    fill: "white",
    transform: "translate(25 27)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpressiveVisuals);
export default __webpack_public_path__ + "static/media/Impressive_Visuals.4180d2c2a2a1879b7957a252297a9d57.svg";
export { ForwardRef as ReactComponent };